import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-loading",
  "use": "icon-loading-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-loading\"><path d=\"M100,51.6c-26.4,0-48,21.6-48,48c0,26.4,21.6,48,48,48s48-21.6,48-48h16c0,35.2-28.8,64-64,64s-64-28.8-64-64s28.8-64,64-64\r\n\tc15.6,0,30.4,6,42,16l6.4-4.4c2-1.6,4.4-1.2,5.6,0.8c0.4,0.8,0.8,1.6,0.8,2.4L154,78.8c0,2.4-1.6,4-4,4h-1.2L121.6,74\r\n\tc-2-0.8-3.2-3.2-2.4-5.2c0.4-0.8,0.8-1.6,1.6-2l7.6-5.6C120.4,55.2,110.4,52,100,51.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol